import mediasMixins from 'root/mixins/mediasMixin.js'
import utilsMixin from 'root/mixins/utilsMixin.js'

export default {
  name: 'facet-nav-refinements',
  mixins: [mediasMixins,utilsMixin],
  props: ['pagedata'],
  data () {
    return {
      accordionActive: []
    }
  },

  methods: {
    toggleInArray: function (collection, item) {
      var idx = _.indexOf(collection, item)
      if (idx !== -1) {
        collection.splice(idx, 1)
      } else {
        collection.push(item)
      }
    },

    bindAccordion: function () {
      var $this = this
      this.$root.$on('facet--accordion--item', function (item) {
        $this.toggleInArray($this.accordionActive, item)
      })
      this.$root.$on('add--facet--accordion--item', function (item) {
        $this.addtoAccordion($this.accordionActive, item)
      })
    },

    addtoAccordion: function (collection, item) {
      var idx = _.indexOf(collection, item)
      if (idx === -1) {
        collection.push(item)
      }
    }

  },

  computed: {
    pageDataComputed() {
      return  _.get(this, '$root.searchPageData') || this.isJson(this.pagedata)
    }
  },

  mounted: function () {
  },

  created: function () {
    this.bindAccordion()
  },

  watch: {
  }
}



// WEBPACK FOOTER //
// ./web/webroot/_ui/responsive/common/js/src/components/facetnavrefinements/facetnavrefinements.js